import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type CallIconProps = IconProps;

export const CallIcon = forwardRef<SVGSVGElement, CallIconProps>(
  function CallIcon(props: CallIconProps, ref) {
    return (
      <Icon
        data-testid="CallIcon"
        aria-label="call"
        viewBox="0 0 12 12"
        ref={ref}
        {...props}
      >
        <path d="M.928 2.367c.016.227.086.531.211.914s.305.808.539 1.277c.242.469.539.957.89 1.465s.762.996 1.23 1.465c.461.469.933.91 1.418 1.324.476.414.922.777 1.336 1.09.422.312.793.562 1.113.75s.551.293.691.316c.281.031.469.043.562.035l.152-.012c.039.008.156-.031.352-.117.187-.086.394-.199.621-.34.227-.148.441-.32.644-.515s.336-.398.398-.609a31.69 31.69 0 0 1-1.113-.562 25.808 25.808 0 0 0-1.101-.562L7.559 9.294l-1.312-.926c-.133-.07-.406-.289-.82-.656a14.977 14.977 0 0 1-1.113-1.113 14.879 14.879 0 0 1-.961-1.16c-.289-.398-.469-.664-.539-.797l-.258-.516.75-.949-.984-2.144c-.359.133-.687.32-.984.562-.289.242-.426.5-.41.773zm7.662 9.631c-.305 0-.672-.109-1.101-.328-.422-.227-.879-.52-1.371-.879-.492-.367-1-.781-1.523-1.242a65.474 65.474 0 0 1-1.523-1.406 9.937 9.937 0 0 1-1.301-1.511 12.22 12.22 0 0 1-.949-1.57 10.27 10.27 0 0 1-.586-1.465 5.701 5.701 0 0 1-.234-1.148 1.353 1.353 0 0 1 .246-.832c.172-.281.394-.531.668-.75.281-.227.586-.418.914-.574S2.471.039 2.767 0l1.652 3.351-.832.961c.086.141.32.445.703.914s.766.898 1.148 1.289c.383.383.781.75 1.195 1.101.422.344.703.555.844.633L8.66 7.37l.375.164.879.387a31.56 31.56 0 0 1 1.77.808l.094.082c.063.055.117.152.164.293.039.141.059.242.059.305v.082c-.141.601-.433 1.07-.879 1.406a7.135 7.135 0 0 1-1.441.855l-.152.059a3.03 3.03 0 0 1-.398.117c-.172.047-.305.07-.398.07h-.141z" />
      </Icon>
    );
  }
);
